import { isEqual } from "lodash";
import { useState, useCallback, useEffect } from "react";

import { UserDTO } from "src/models/user";
import { MailInboxUploaderQuickFilter } from "./interfaces";

export const useMailInboxUploaderQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<MailInboxUploaderQuickFilter>({
    mailInboxUploaders: {
      mailInboxUploaderIds: [],
    },
  });

  useEffect(() => {
    setQuickFilter({
      mailInboxUploaders: {
        mailInboxUploaderIds: [],
      },
    });
  }, []);

  const [selectedMailInboxUploader, setSelectedMailInboxUploader] = useState<UserDTO | null>(null);

  const handleChangeQuickFilter = useCallback(
    (
      filter: keyof MailInboxUploaderQuickFilter,
      value: MailInboxUploaderQuickFilter["mailInboxUploaders"],
      item: UserDTO | null
    ) => {
      if (isEqual(value, quickFilter[filter])) return;

      setQuickFilter((state) => ({ ...state, [filter]: value }));
      setSelectedMailInboxUploader(item);

      localStorage.setItem("QF_MIU", JSON.stringify(value));
    },
    [quickFilter]
  );

  return {
    mailInboxUploaderQuickFilter: quickFilter,
    setMailInboxUploaderQuickFilter: handleChangeQuickFilter,
    selectedMailInboxUploader,
  };
};
